import { getThemeData, emptyCSSTemplateFunc } from '@hzero-front-ui/core';
import { css } from 'styled-components';
var getAlertStyle = function getAlertStyle(props) {
  var _getThemeData = getThemeData(props, 'alert'),
    iconSize = _getThemeData.iconSize,
    withDescriptionIconSize = _getThemeData.withDescriptionIconSize,
    iconPositionTop = _getThemeData.iconPositionTop,
    iconPositionLeft = _getThemeData.iconPositionLeft,
    withDescriptionPadingLeft = _getThemeData.withDescriptionPadingLeft,
    iconPosWithDescriptionTop = _getThemeData.iconPosWithDescriptionTop,
    iconPosWithDescriptionLeft = _getThemeData.iconPosWithDescriptionLeft;
  return css([".c7n-alert{&&:not(.c7n-alert-with-description){.c7n-alert-icon{font-size:", ";top:", ";left:", ";}}&&.c7n-alert-with-description{.c7n-alert-icon{font-size:", ";left:", ";top:", ";}}}"], iconSize, iconPositionTop, iconPositionLeft, withDescriptionIconSize, iconPosWithDescriptionLeft, iconPosWithDescriptionTop);
}; // 该文件夹内只放和 theme5 有区别，需要覆盖的变量

var alertData = {
  name: 'alert',
  data: [{
    iconSize: '.18rem',
    withDescriptionIconSize: '.24rem',
    iconPositionTop: '.09rem',
    iconPositionLeft: '.16rem',
    // withDescriptionPadingLeft: 51,
    iconPosWithDescriptionTop: '.16rem',
    iconPosWithDescriptionLeft: '.24rem'
  }],
  // 开启数据替换
  replaceData: true,
  // 不做样式覆盖  使用 c7n-ui 样式
  onlyTemplate: {
    base: getAlertStyle,
    hzero: emptyCSSTemplateFunc
  }
};
export default alertData;